import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    getTodayDateISO,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { searchWastage, deleteWastage } from "../../../Helpers/apiCalls/Reports/DailyWastageApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";

import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import Footer from "../../../Components/Footer/Footer";

export default function SalesByItem() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [wastage, setWastage] = useState([]);
    const [wastageItems, setWastageItems] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);
    const [averagePrice, setAveragePrice] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);
    const [items, setItems] = useState([]);
    const [isClicked, setIsClicked] = useState(false);

    const date = new Date();
    date.setDate(date.getDate() - 7);

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const today = Moment().format("MM/DD/YYYY");

    const excelHeaders = [
        { label: "Branch Name", key: "branch_name" },
        { label: "Date", key: "wastage_date" },
        { label: "Item", key: "name" },
        { label: "Quantity", key: "qty" },
        { label: "Unit", key: "unit" },
        { label: "Reason", key: "reason" },
        { label: "Wastage By", key: "wasted_by_name" },
        { label: "Remarks", key: "remarks" },
    ];

    const dummy = [
        {
            id: "1",
            branch_name: "SM CITY CEBU",
            date: "December 2022",
            remarks: "asdfasdf",
        },
    ]

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    async function fetchAllItems() {
        const response = await getAllItems();

        if (response.response.data) {
            var data = response.response.data.map((item) => {
                var info = item;
                info.label = item.name
                info.value = item.id
                return info;
            });
            setItems([{label: "All Items", value:""}, ...data]);
        } else {
        }
    }

    async function fetchBranches() {
        setShowLoader(true);

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data.map((data) => {
                var branch = data;
                return branch;
            });
            setBranches(allBranches);
        }
        setShowLoader(false);
    }

    async function fetchData() {
        setShowLoader(true);
        setWastage([])
        setWastageItems([])
        setTotalQuantity(0)
        var array = []

        const response = await searchWastage(filterConfig);
        

        if (response.error) {
        } else {

            var allBills = response.data.data.map((bill) => {
                
                var info = bill;
                info.wastage_date = Moment(bill.wastage_date).format("MM-DD-YYYY")
                info.wastage_items.map((data) => {
                    var details = data;
                    data.branch_name = bill.branch_name
                    data.wastage_date = bill.wastage_date
                    array.push(data)
                })
                return info;
            });
            
            setWastage(allBills)
            setWastageItems(array)

            var qty = response.data.summary?.total_quantity? response.data.summary.total_quantity : "0";
            setTotalQuantity(qty);
        }
        setShowLoader(false);
    }

    async function handleDeleteWastage() {
        setIsClicked(true);
        const response = await deleteWastage(selectedRow.id);
        if (response.data) {
            toast.success("Wastage Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Wastage", {
                style: toastStyle(),
            });
        }
    }

    React.useEffect(() => {
        fetchAllItems();
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> WASTAGE REPORTS </h1>
                    </Col>
                    <Col xs={12} lg={5} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="branch_name"
                            placeholder="Search branch name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Item"
                            styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                  borderRadius: "7px",
                                  border: "0px",
                                  minHeight: "20px",
                                  maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                  }),
                                  dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                  }),
                                  
                              }}
                            // value={branch}
                            options={items}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "item_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={Moment(date).format("MM/DD/YYYY")}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="my-2 px-2 PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 align-middle mt-2 ps-label">
                            Total Quantity: {numberFormat(totalQuantity)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "DATE",
                                "BRANCH",
                                "ITEM",
                                "QUANTITY",
                                "UNIT",
                                "CHARGE AMOUNT",
                                "CHARGED TO",
                                "REASON",
                                "WASTAGE BY",
                                "REMARKS",
                            ]}
                            headerSelector={[
                                "wastage_date",
                                "branch_name",
                                "name",
                                "qty",
                                "unit",
                                "wastage_cost",
                                "wastage_charged_to",
                                "reason",
                                "wasted_by_name",
                                "remarks",
                            ]}
                            tableData={wastageItems}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                <br />
                <Row>
                    <Col xs={12} lg={9}></Col>
                    <Col xs={12} lg={3} className="mt-3 mt-lg-0">
                        <div className="PO-filters">
                        <CSVLink
                        type="button"
                        className="add-btn download-csv px-4 py-1"
                        data={wastageItems}
                                headers={excelHeaders}
                                target="_blank"
                                filename={`${getTodayDateISO()} Wastage Reports`}
                    >
                        <span className="ms-3">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                <span className="ms-2">Download Excel</span>
                        </CSVLink>
                        </div>
                    </Col>
                </Row>
                <br />
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="wastage"
                onDelete={handleDeleteWastage}
                isClicked={isClicked}
            />
            <Footer/>
        </div>
    );
}
